module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02-m.09357a9470c4da50de883f2a02183659.png";